<div class="mat-elevation-z8">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="announceSortChange($event)"
  >
    <ng-container matColumnDef="partner">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by partner"
      >
        Nom du partenaire
      </th>
      <td mat-cell *matCellDef="let element">{{ element.partner }}</td>
    </ng-container>

    <ng-container matColumnDef="clientCode">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by clientCode"
      >
        Code client
      </th>
      <td mat-cell *matCellDef="let element">{{ element.clientCode }}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by date"
      >
        Date/Heure de consommation
      </th>
      <td mat-cell *matCellDef="let element">{{ element.happened_at }}</td>
    </ng-container>

    <ng-container matColumnDef="typeDeBien">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by typeDeBien"
      >
        Type de bien
      </th>
      <td mat-cell *matCellDef="let element">{{ element.propertyType }}</td>
    </ng-container>

    <ng-container matColumnDef="nombreReferences">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by nombreReferences"
      >
        Nombre de références
      </th>
      <td mat-cell *matCellDef="let element">{{ element.resultCount }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    aria-label="Select page of periodic elements"
  >
  </mat-paginator>
</div>
